import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ReactComponent as Success } from 'assets/icons/success.svg';
import { ReactComponent as WarningRed } from 'assets/icons/warning-red.svg';
import { Modal, TextAreaField, Label } from 'components';
import { isInvestor,  outcomes,isRejectedStatus, isSubmitter, isObjectionCommittee, isCommittee, committeeOutcomes } from 'utils';
import { radioOptions } from './utils';
import { updateFormField } from 'store/forms/actions';
import { Radio } from 'antd';
import isEmpty from 'lodash/isEmpty';
import { isBeneficiary, isAuditor, auditorOutcomes } from 'utils';

const SubmitModal = ({
  isVisible,
  setIsVisible,
  handleSubmit,
  submitDisabled,
  formKey,
  outcome,
  businessKey,
}) => {
  const dispatch = useDispatch();
  const rejectKtpReason = useSelector(state => state.forms?.carrier?.rejectKtpReason);
  const rejectKtpMessage = useSelector(state => state.forms?.carrier?.rejectKtpMessage);
  const rejectAuditorMessage = useSelector(state => state.forms?.carrier?.rejectAuditorMessage);
  const returnAuditorMessage = useSelector(state => state.forms?.carrier?.returnAuditorMessage);
  const withdrawCommitteeMessage = useSelector(state => state.forms?.carrier?.withdrawCommitteeMessage);
  const user = useSelector(state => state.user);
  const isUserKTP = ( user?.groups?.filter(a => a.id.startsWith("KTP")).length >0 );
  const isUserProvider = ( user?.groups?.filter(a => a.id.startsWith("ProviderResourceGroup")).length >0 );
  const taskName = useSelector(state => state.forms.task.taskName);
  const rejectKtp = outcome === outcomes.rejectKtp;
  const returnAuditor = outcome === outcomes.returnAuditor;
  const approveAuditor = outcome === auditorOutcomes.approveAuditor;
  const rejectAuditor = outcome === auditorOutcomes.rejectAuditor;
  const finalApproveCommittee = outcome === committeeOutcomes.finalApproveCommittee;
  const withdrawCommittee = outcome === committeeOutcomes.withdrawCommittee;
 
  const renderContent = () => {
    const isUserAuditor = isAuditor(user?.groups);
    const isUserCommittee = isCommittee(user?.groups);

    // Handle auditor cases first
    if (isUserAuditor && (approveAuditor || rejectAuditor)) {
      return (
        <div>
          <br/>
          <div className="content-title color-blue-3 font-size-24">
            {rejectAuditor
              ? 'Απόρριψη Αίτησης'
              : 'Έγκριση Αίτησης'}
          </div>
          <br/>
          <div className="content-paragraph">
            {rejectAuditor ? (
              <div>
                <div className="mb-2">
                  Είστε βέβαιος/-η ότι επιθυμείτε να κάνετε απόρριψη της αίτησης;
                  <br />
                  <br />
                  Η ενέργεια είναι μη αναστρέψιμη.
                </div>
                <div className="mt-2">
                  <TextAreaField
                    label={'Μήνυμα Απόρριψης'}
                    placeholder={'Προσθήκη Σχολίου'}
                    asterisk={true}
                    name={'rejectAuditorMessage'}
                    value={rejectAuditorMessage}
                    maxLength={500}
                    onChange={event =>
                      dispatch(
                        updateFormField({
                          group: 'carrier',
                          key: 'rejectAuditorMessage',
                          value: event.target.value,
                        })
                      )
                    }
                  />
                </div>
              </div>
            ) : (
              <>
                Είστε βέβαιος/-η ότι επιθυμείτε να κάνετε οριστική έγκριση της αίτησης;
                <br />
                <br />
                Η ενέργεια είναι μη αναστρέψιμη.
              </>
            )
          }
          </div>
        </div>
      );
    }

    // Handle committee cases
    if (isUserCommittee && (finalApproveCommittee || withdrawCommittee)) {
      return (
        <div>
          <br/>
          <div className="content-title color-blue-3 font-size-24">
            {withdrawCommittee
              ? 'Απένταξη Αίτησης'
              : 'Ένταξη Αίτησης'}
          </div>
          <br/>
          <div className="content-paragraph">
            {withdrawCommittee ? (
              <div>
                <div className="mb-2">
                  Είστε βέβαιος/-η ότι επιθυμείτε να κάνετε οριστική απένταξη της αίτησης;
                  <br />
                  <br />
                  Η ενέργεια είναι μη αναστρέψιμη.
                </div>
                <div className="mt-2">
                  <TextAreaField
                    label={'Μήνυμα'}
                    placeholder={'Προσθήκη Σχολίου'}
                    asterisk={true}
                    name={'withdrawCommitteeMessage'}
                    value={withdrawCommitteeMessage}
                    maxLength={500}
                    onChange={event =>
                      dispatch(
                        updateFormField({
                          group: 'carrier',
                          key: 'withdrawCommitteeMessage',
                          value: event.target.value,
                        })
                      )
                    }
                  />
                </div>
              </div>
            ) : (
              <>
                Είστε βέβαιος/-η ότι επιθυμείτε να κάνετε οριστική ένταξη της αίτησης;
                <br />
                <br />
                Με την ενέργειά σας αυτή η αίτηση πηγαίνει στο στάδιο <strong>Έναρξη Προγράμματος</strong>.
                <br />
                <br />
                Η ενέργεια είναι μη αναστρέψιμη.
              </>
            )
          }
          </div>
        </div>
      );
    }

    if (isBeneficiary(user?.groups)) {
      if (taskName === "task.name.submit_application"){
        return (
          <div>
            <div className="content-title color-blue-3 font-size-24 mb-2">
            Υποβολή Αίτησης
          </div>Πρόκειται να υποβάλετε αίτηση χρηματοδότησης στο Πρόγραμμα "Ενεργειακή Αναβάθμιση Παιδικοί Σταθμοί & Νηπιαγωγεία - Δημοτικά Σχολεία". Παρακαλούμε επιβεβαιώστε την ενέργεια διαφορετικά επιλέξτε Ακύρωση. 
          </div>
          )
      }
    } else if(isUserKTP){
      return (
        <div>
          <br/>
          <div className="content-title color-blue-3 font-size-24">
            {rejectKtp
              ? 'Απόρριψη Αίτησης'
              : 'Έγκριση Αίτησης'}
          </div>
          <br/>
          <div className="content-paragraph">
            {rejectKtp ? (
              <div>
                <div className="mb-2">
                  Για να οριστικοποιήσετε την Απόρριψη της Αίτησης, παρακαλούμε επιλέξτε την Αιτιολογία Απόρριψης και πατήστε "Επιβεβαίωση". 
                  Διαφορετικά, μπορείτε να επιλέξετε "Επιστροφή". Η ενέργεια είναι μη αναστρέψιμη.
                </div>
                <Label
                  label={'Αιτιολογία Απόρριψης'}
                  asterisk={true}
                  customClass={'text-bold'}
                />
                <Radio.Group
                  className={'reject-modal-radio-options'}
                  options={radioOptions}
                  value={rejectKtpReason}
                  size="small"
                  onChange={event =>{
                    dispatch(
                      updateFormField({
                        group: 'carrier',
                        key: 'rejectKtpReason',
                        value: event.target.value,
                      })
                    )
                  }
                  }
                />
                {
                  rejectKtpReason?.includes('Λόγος Απόρριψης') &&
                  <div className="mt-2">
                  <TextAreaField
                    label={'Μήνυμα Απόρριψης'}
                    placeholder={'Προσθήκη Σχολίου'}
                    asterisk={true}
                    name={'rejectKtpMessage'}
                    value={rejectKtpMessage}
                    maxLength={500}
                    onChange={event =>
                      dispatch(
                        updateFormField({
                          group: 'carrier',
                          key: event.target.name,
                          value: event.target.value,
                        })
                      )
                    }
                  />
                </div>
              }
              </div>
            ) : (
              'Για να οριστικοποιήσετε την Έγκριση της αίτησης, παρακαλούμε πατήστε το κουμπί "Επιβεβαίωση". Διαφορετικά, μπορείτε να επιλέξετε "Επιστροφή". Η ενέργεια είναι μη αναστρέψιμη.'
            )
          }
          </div>
        </div>
      );
    } else if(isAuditor(user?.groups) && returnAuditor){
      return (
        <div>
          <div className="content-title color-blue-3 font-size-24 mb-2">
            Επιστροφή στον Δικαιούχο
          </div>
          <p>Επιβεβαιώνοντας την ενέργεια αυτή, πατώντας την επιλογή Επιστροφή στον Δικαιούχο, σημαίνει ότι εντοπίστηκαν ελλείψεις ή απαιτούνται διορθώσεις στα δικαιολογητικά για την αίτηση με αριθμό {businessKey}. Παρακαλώ πληκτρολογείστε σχετικό μήνυμα προς τον Δικαιούχο. Διαφορετικά, επιλέξτε Άκυρο.</p>
          <div className="mt-2">
            <TextAreaField
              label={'Μήνυμα'}
              placeholder={'Προσθήκη Σχολίου'}
              asterisk={true}
              name={'returnAuditorMessage'}
              value={returnAuditorMessage}
              maxLength={500}
              onChange={event =>
                dispatch(
                  updateFormField({
                    group: 'carrier',
                    key: event.target.name,
                    value: event.target.value,
                  })
                )
              }
            />
          </div>
        </div>
      )
    }
  };

  const submit = (() => {
    setIsVisible(false);
    handleSubmit();
  })

  return (
    <>
    <Modal
      isVisible={isVisible}
      handleCancel={() => {
        setIsVisible(false)
        if (outcome === outcomes.rejectKtp) {
          dispatch(updateFormField({
            group: 'carrier',
            key: 'rejectKtpReason',
            value: null,
          }))
          dispatch(updateFormField({
            group: 'carrier',
            key: "rejectKtpMessage", 
            value: null,
          }))
        } 
        else if (outcome === auditorOutcomes.rejectAuditor) {
          dispatch(updateFormField({
            group: 'carrier',
            key: "rejectAuditorMessage",
            value: null,
          }))
        }
        else if(returnAuditor){
          dispatch(updateFormField({
            group: 'carrier',
            key: "returnAuditorMessage",
            value: null,
          }));
        }
        else if (outcome === committeeOutcomes.withdrawCommittee) {
          dispatch(updateFormField({
            group: 'carrier',
            key: "withdrawCommitteeMessage",
            value: null,
          }))
        }
      }}
      handleConfirm={submit}
      width={
        outcome === outcomes.returnAuditor
          ? 600
          : 400
      }
      cancelText={returnAuditor ? 'Άκυρο' : 'Ακύρωση'}
      okText={
        isBeneficiary(user?.groups)
          ? 'Υποβολή'
          : isCommittee(user?.groups) && finalApproveCommittee
          ? "Ένταξη"
          : isCommittee(user?.groups) && withdrawCommittee
          ? "Απένταξη"
          : outcome === outcomes.returnAuditor
          ? 'Επιστροφή στον Δικαιούχο'
          : (rejectKtp || rejectAuditor) 
          ? 'Απόρριψη'
          : 'Επιβεβαίωση'
      }
      submitDisabled={
        (outcome === outcomes.returnAuditor && isEmpty(returnAuditorMessage)) ||
        (outcome === auditorOutcomes.rejectAuditor && isEmpty(rejectAuditorMessage)) ||
        (outcome === committeeOutcomes.withdrawCommittee && isEmpty(withdrawCommitteeMessage)) ||
        (outcome === outcomes.rejectKtp && isEmpty(rejectKtpReason))
      }
      formKey={formKey}
      Icon={ 
        (outcome === outcomes.rejectKtp 
          || outcome === auditorOutcomes.rejectAuditor 
          || outcome === committeeOutcomes.withdrawCommittee) 
          ? WarningRed 
          : Success 
      }
      outcome={outcome}
      okButtonClassName={
        (rejectKtp || rejectAuditor || withdrawCommittee) 
          ? 'custom-modal__submit-button custom-modal__submit-button--reject' 
          : 'custom-modal__submit-button'
      }
      user={user}
    >
      <div className="modal-submit-content">{renderContent()}</div>
    </Modal>
    </>
  );
};

export default SubmitModal;